export const AddressFieldsHelper = {
	setFormData: (form, data) => {
		form.setValues({
			zipCode: data.cep || '',
			street: data.logradouro || '',
			complement: '',
			number: '',
			neighborhood: data.bairro || '',
			city: data.localidade || '',
			state: data.uf || ''
		})
	},
	isAddressDuplicated: (address, addresses) => {
		const isDuplicated = addresses.some(
			({ id, number, zipCode, complement }) =>
				(address.id === undefined || address.id !== id) &&
				number === address.number &&
				zipCode === address.zipCode &&
				(complement || '').toUpperCase() ===
					(address.complement || '').toUpperCase()
		)

		return isDuplicated
	}
}
